<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
            <template v-slot:body>
                <b-row>
                    <b-col lg="12" sm="12">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                        <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset" enctype="multipart/form-data">
                            <b-row v-for="(committee,index) in committees" :key="index">
                                <b-col lg="3" sm="4">
                                    <ValidationProvider name="Role" vid="role_id" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="3"
                                            :label="$t('complain.role')"
                                            label-for="role_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-select
                                                plain
                                                :id="committee.role_id.toString()"
                                                v-model="committee.role_id"
                                                :options="committee.roleList"
                                                @change="getUserList(committee)"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="3" sm="4">
                                    <ValidationProvider name="User" vid="user_id" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="3"
                                            :label="$t('complain.user')"
                                            label-for="user_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-select
                                                plain
                                                :id="committee.user_id.toString()"
                                                v-model="committee.user_id"
                                                :options="committee.userList"
                                                @change="getDesignationList(committee)"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="5" sm="4">
                                    <ValidationProvider name="Designation" vid="designation_id" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            :label="$t('organogram.designation')"
                                            label-for="designation_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-select
                                                plain
                                                :id="committee.designation_id.toString()"
                                                v-model="committee.designation_id"
                                                :options="committee.designationList"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="1" sm="4">
                                    <b-button v-if="index !== 0" variant=" iq-bg-danger" size="sm" @click.prevent="removeCommittee(index)"><i class="ri-delete-bin-line m-0"></i></b-button>
                                    <b-button v-if="index === 0" variant=" iq-bg-success" size="sm" @click="addNew"><i class="ri-add-line m-0"></i></b-button>
                                </b-col>
                            </b-row>
                            <b-button type="submit" variant="primary">{{ saveBtnName}}</b-button>
                        </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { authServiceBaseUrl, commonServiceBaseUrl } from '../../../../../config/api_config'
import { assignCommitteeList, getCommitteeList } from '../../api/routes'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.id) {
        const tmp = this.getComplainCommitteeInfo()
        if (!tmp) {
            this.getRoleList()
        } else {
            this.committees = tmp
        }
        this.getRoleList()
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
        saveBtnName: this.$t('globalTrans.save'),
        committees: [
            {
                complain_id: this.id,
                role_id: 0,
                user_id: 0,
                designation_id: 0,
                userList: [],
                roleList: [],
                designationList: []
            }
        ],
        roleObject: [],
        committee: [
            {
                role_id: 0,
                user_id: 0,
                designation_id: 0
            }
        ],
        designationList: [],
        editMode: false
    }
  },
  computed: {
      ...mapGetters({
          allUserList: 'UserManagement/userList'
      })
  },
  watch: {
  },
  methods: {
    getRoleList () {
        const user = this.$store.state.Auth.authUser
        RestApi.getData(authServiceBaseUrl, 'role/role-list-select/' + user.org_id)
        .then(response => {
            const roleObject = response.map((obj, index) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.role_name_bn }
                } else {
                    return { value: obj.id, text: obj.role_name }
                }
            })
            this.committees.map(item => {
                item.roleList = roleObject
                item.userList = this.getUserList(item)
                item.designationList = this.getDesignationList(item)
                return Object.assign({}, item, item.roleList, item.userList, item.designationList)
            })
        })
    },
    getUserList (committee) {
        if (committee.role_id) {
            RestApi.getData(authServiceBaseUrl, 'user/userListByRoleId/' + committee.role_id)
            .then(response => {
                committee.userList = response.map((obj, index) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.user_id, text: obj.name_bn }
                    } else {
                        return { value: obj.user_id, text: obj.name }
                    }
                })
            })
        }
    },
    getDesignationList (committee) {
        const designationList = this.$store.state.commonObj.designationList
        RestApi.getData(authServiceBaseUrl, 'user/getUserByUserId/' + committee.user_id)
        .then(response => {
            const designationObject = designationList.filter(designation => designation.value === response.designation_id)
            committee.designationList = designationObject.map((obj, index) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        })
    },
    async getComplainCommitteeInfo () {
        const result = await RestApi.getData(commonServiceBaseUrl, `${getCommitteeList}/${this.id}`)
        if (result.success && result.data.length > 0) {
            this.committees = result.data
        } else {
            const tmpCommittee = {
                complain_id: this.id,
                role_id: 0,
                user_id: 0,
                designation_id: 0,
                roleList: this.getRoleList(),
                userList: [],
                designationList: []
            }
            this.committees = []
            this.committees.push(tmpCommittee)
        }
    },
    addNew () {
        const user = this.$store.state.Auth.authUser
        RestApi.getData(authServiceBaseUrl, 'role/role-list-select/' + user.org_id)
        .then(response => {
            this.roleObject = response.map((obj, index) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.role_name_bn }
                } else {
                    return { value: obj.id, text: obj.role_name }
                }
            })
            const tmpCommittee = {
                    complain_id: this.id,
                    role_id: 0,
                    user_id: 0,
                    designation_id: 0,
                    userList: [],
                    roleList: this.roleObject,
                    designationList: []
            }
            this.committees.push(tmpCommittee)
        })
    },
    removeCommittee (key) {
        if (key !== 0) {
            this.committees.splice(key, 1)
        }
    },
    async register () {
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        let result = null
        const loadinState = { loading: false, listReload: true }
        result = await RestApi.postData(commonServiceBaseUrl, assignCommitteeList, this.committees)
        this.$store.dispatch('mutateCommonProperties', loadinState)
        if (result.success) {
            this.$toast.success({
                title: 'Success',
                message: this.id ? 'Committeee updated successfully' : 'Committeee save successfully',
                color: '#D6E09B'
            })
            this.$bvModal.hide('modal-6')
        } else {
            this.$refs.form.setErrors(result.errors)
        }
    }
  }
}
</script>
